import { render, staticRenderFns } from "./housingAssets.vue?vue&type=template&id=06cbb364&scoped=true"
import script from "./housingAssets.vue?vue&type=script&lang=js"
export * from "./housingAssets.vue?vue&type=script&lang=js"
import style0 from "./housingAssets.vue?vue&type=style&index=0&id=06cbb364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbb364",
  null
  
)

export default component.exports